document.addEventListener("DOMContentLoaded", function () {
  var testimonialCarousels = document.querySelectorAll("[data-home-testimonials]");

  testimonialCarousels.forEach(function (carousel) {
    var track = carousel.querySelector("[data-home-testimonials-track]");
    var slides = carousel.querySelectorAll("[data-home-testimonials-slide]");
    var dots = carousel.querySelectorAll("[data-home-testimonials-dot]");
    var currentIndex = 0;
    var intervalId;

    if (!track || slides.length < 2) {
      return;
    }

    var getGap = function () {
      var styles = window.getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap) || 0;
    };

    var goToSlide = function (index) {
      currentIndex = (index + slides.length) % slides.length;

      var offset = currentIndex * (slides[0].getBoundingClientRect().width + getGap());
      track.style.transform = "translateX(-" + offset + "px)";

      dots.forEach(function (dot) {
        var isActive = Number(dot.getAttribute("data-home-testimonials-dot")) === currentIndex;
        dot.classList.toggle("home-testimonials__dot--active", isActive);

        if (isActive) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });
    };

    var startCarousel = function () {
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        return;
      }

      stopCarousel();
      intervalId = window.setInterval(function () {
        goToSlide(currentIndex + 1);
      }, 5000);
    };

    var stopCarousel = function () {
      if (intervalId) {
        window.clearInterval(intervalId);
        intervalId = null;
      }
    };

    carousel.addEventListener("mouseenter", stopCarousel);
    carousel.addEventListener("mouseleave", startCarousel);
    carousel.addEventListener("focusin", stopCarousel);
    carousel.addEventListener("focusout", startCarousel);

    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        var targetIndex = Number(dot.getAttribute("data-home-testimonials-dot"));

        if (Number.isNaN(targetIndex)) {
          return;
        }

        stopCarousel();
        goToSlide(targetIndex);
        startCarousel();
      });
    });

    window.addEventListener("resize", function () {
      goToSlide(currentIndex);
    });

    goToSlide(0);
    startCarousel();
  });
});
